import { TARGET_SCOPES, TargetScope } from "@/types/Workflow";

/**
 * The scope an action actually runs against, mirroring the consumer's own
 * `readTargetScope` (`main-consumer/src/workflows/guest-target-resolver.ts`).
 *
 * The fallback is the whole point: the consumer validates against the union and
 * FALLS BACK to "triggering" rather than skipping, so an unrecognised or absent
 * value still writes the triggering guest. Any caller that treats "unknown" as
 * "no target" under-predicts what production does.
 *
 * Extracted from `workflow-overwrite-preview.ts`, which had it inline, so the
 * editor-time warnings and the save-time overwrite preview cannot disagree about
 * what a stored config means.
 */
export function readTargetScope(
  config: Record<string, unknown> | null | undefined,
): TargetScope {
  const raw = config?.["targetScope"];
  return TARGET_SCOPES.includes(raw as TargetScope)
    ? (raw as TargetScope)
    : "triggering";
}
